import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoMdCalendar, IoMdDoneAll, IoIosEye, IoMdDownload, IoMdRefresh } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from '../../../components/Loader';
import moment from 'moment';
import { FaTimes} from "react-icons/fa";
import getExcel from "../../../_services/ExcelUtility";

const ErrorsPage = () => {
    const fileName = 'Errors'
    const [startDate, setStartDate] = useState(new Date());
    const [errorFiles, setErrorFiles] = useState([]);
    const [loading, setLoading] = useState(false);

    let filterStartDate = moment(startDate).format("L")
    const [validated, setValidated] = useState(false)
    const [btnDisable, setBtnDisable] = useState(true)
    const [greaterErr, setGreaterErr] = useState(false)
    const [emptyErr, setEmptyErr] = useState(false)
    const [errorReportError, setErrorReportError] = useState(false)
    const [viewReportError, setViewReportError] = useState(false)
    const [taskType, setTaskType] = useState(0)
    const [show, setShow] = useState(false);
    const [errorDetails, setErrorDetails] = useState([]);

    const columns = [
        {
            Header: "Errors / Comments",
            accessor: 'accessor',
            disableFilters: true,
            disableSortBy: true, width: 150,
            Cell: ({ row: { original } }) => (
                <Fragment>
                    {original.ErrorDescription == "N/A" || original.ErrorDescription == null ?  '' :
                        <Button variant="link" onClick={() => viewErrors(original.FileProcessId)} className="grid-action-btn ml-2" title="View Errors">
                            <IoIosEye className="icon" />
                        </Button>
                    }
                    <Button variant="link" onClick={() => fileReProcess(original.FileProcessId)} className="grid-action-btn ml-2" title="Re-Process">
                     <IoMdRefresh className="icon" />
                   </Button>
                </Fragment>
            )
        },
        {
            Header: "Task Name",
            accessor: "TaskName",
            filter: "TaskName",
            sortType: "basic", width: 190
        },
        {
            Header: "File Name",
            accessor: "FileName",
            filter: "FileName",
            sortType: "basic", width: 270,
            Cell: ({ row: { original } }) => (
                <Fragment>
                    <span className="word-wrap">{original.FileName}</span>
                </Fragment>
            )
        },
        {
            Header: "Source",
            accessor: "Source",
            filter: "Source",
            sortType: "basic", width: 120
        },
        {
            Header: "File Received/Generated Timestamp",
            accessor: "FileProcessRcvdDate",
            filter: "FileProcessRcvdDate",
            sortType: "basic", width: 170
        },
        {
            Header: "Process Start Timestamp",
            accessor: "FileProcessStartDate",
            filter: "FileProcessStartDate",
            sortType: "basic", width: 170
        },
        {
            Header: "Process End Timestamp",
            accessor: "FileProcessEndDate",
            filter: "FileProcessEndDate",
            sortType: "basic", width: 170
        },
        {
            Header: "Elapsed Time",
            accessor: "ElapsedTime",
            filter: "ElapsedTime",
            sortType: "basic", width: 180
        },
        {
            Header: "File Size",
            accessor: "FileSize",
            filter: "FileSize",
            sortType: "basic", width: 90
        },
        {
            Header: "Row Count",
            accessor: "FileRowCount",
            filter: "FileRowCount",
            sortType: "basic", width: 120
        },
        {
            Header: "Status",
            accessor: "Status",
            disableFilters: true,
             disableSortBy: true, width: 140,
            Cell: ({ row: { original } }) => (
                <Fragment>
                     {/* {original.Status ="&#10013;"} */}
                     {/* &#10060; */}
                     <FaTimes title="Failed" style={{fontSize:'20px',color:'#f11f0f'}}/>
                 </Fragment>
             )
        }
    ];

    const errorDetaileColumns = [
        {
            Header: "Timestamp",
            accessor: "ErrorCreatedDate",
            width: 150
        },
        {
            Header: "File Name",
            accessor: "FileProcessName",
            width:300
        },
        {
            Header: "Error Description",
            accessor: "ErrorDescription",
            width: 650
        },
    ];


    useEffect(()=>{
        getErrors();

    },[])

    const fileReProcess = (fileProcessID) =>{
        setLoading(true);
        _HttpServices
            .postData(`Api/services/UpdateFileProcess?FileProcessId=${fileProcessID}`)
            .then((data) => {
                const reprocessData = data.data;
               
                setErrorDetails(errorDetails);
                setLoading(false);
                getErrors();
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
            });
    }

    const viewErrors = (fileProcessID) => {
        setShow(true);
        setLoading(true);
        _HttpServices
            .getData(`Api/Chart/GetFileProcessesErrors?processesID=${fileProcessID}`)
            .then((data) => {
                const errorDetails = data.data;
                if (errorDetails.length > 0) {
                    errorDetails.map((res) => {
                        res.ErrorCreatedDate = moment(res.ErrorCreatedDate).format('MM/DD/YYYY h:mm:ss A')
                    })
                }
                setErrorDetails(errorDetails);
                setLoading(false);
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
                setViewReportError(true)
            });
    }
    
    const handleClose = () => setShow(false);
    const submitHandler = (e) => {
        e.preventDefault()
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault()
            e.stopPropagation()
            setValidated(true)
        } else {
            e.preventDefault()
            if (startDate === 0) {
                setEmptyErr(true)
                return false
            }

            filterStartDate = moment(startDate).format("L")

            getErrors()

            setBtnDisable(true)
            setValidated(false)
        }
    }

    const getErrors = () => {
        setLoading(true);
        _HttpServices
            .getData(`api/chart/GetFileProcessesError?Taskdate=${filterStartDate}&FileSourceType=${taskType}`)
            .then((data) => {
                const errorsFileResult = data.data;
                if (errorsFileResult.length > 0) {
                    errorsFileResult.map((res) => {
                        res.FileProcessRcvdDate = moment(res.FileProcessRcvdDate).format('MM/DD/YYYY h:mm:ss A')
                        res.FileProcessStartDate = moment(res.FileProcessStartDate).format('MM/DD/YYYY h:mm:ss A')
                        res.FileProcessEndDate = res.FileProcessEndDate == null? "": moment(res.FileProcessEndDate).format('MM/DD/YYYY h:mm:ss A')
                    })
                }
                setErrorFiles(errorsFileResult);
                setLoading(false);
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
                setErrorReportError(true)
            });
    };

    return (
        <Row>
            <Col md={12}>
                <div className="card pt-2 mb-4">
                    <div className="card-body">
                        {errorDetails.length > 0 ?
                        <Button  type="button" className="dashboard-excel-btn" onClick={()=>getExcel(columns,errorFiles,fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>
                        : null}
                        <Form noValidate validated={validated} onSubmit={submitHandler}>
                            <Row>
                                <Col md={3}>
                                    <Form.Group>
                                        <div className="date-picker ungroup-date-picker pos-rl">
                                            <Form.Label htmlFor="StartDate">
                                                Date
                                            </Form.Label>
                                            <IoMdCalendar className="icon date-icon" />
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) => {
                                                    if(date){
                                                        setBtnDisable(false)
                                                        return setStartDate(date)
                                                    }else {
                                                        setBtnDisable(true)
                                                    }
                                                    
                                                }}
                                                maxDate={new Date()}
                                                required className={emptyErr ? "form-control is-invalid" : "form-control"}
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group controlId="formLastName">
                                        <Form.Label>
                                            Select Type
                                        </Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="taskType"
                                            type="text"
                                            value={taskType}
                                            onChange={e => {
                                                setBtnDisable(false)
                                                return setTaskType(e.target.value)
                                            }}>

                                            <Fragment>

                                                <option id="0" value="0">All</option>
                                                <option id="1"value="1">All In-bound </option>
                                                <option id="2"value="2">All Out-bound.</option>

                                            </Fragment>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group className="mt-2">
                                        <Button type="submit" className="mt-3"
                                            disabled={btnDisable}
                                        >
                                            <IoMdDoneAll className="icon btn-icon" />
                                            Submit
                                        </Button>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
                <div className="card pt-2">
                    <div className="card-body">                        
                        <div className="error-files-grid">
                            <Fragment>
                                {loading ? <Loader /> : errorFiles.length > 0 ? (
                                    <ReactTable columns={columns} data={errorFiles} defaultPageSize={10} />
                                ) : errorReportError ? <p>Error occurred. Unable to load error reports.</p> : (
                                        <div className="no-data">No data found.</div>
                                    )}
                            </Fragment>
                        </div>
                    </div>
                </div>

                {/* model */}
                <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
                     <Modal.Header closeButton>
                        <h4 className="h4">View Error</h4>
                    </Modal.Header> 
                    <Modal.Body>
                        <div className="card pt-2">
                            <div className="card-body">
                                <div className="inventory-grid">
                                    <Fragment>
                                        {loading ? <Loader /> : errorDetails.length > 0 ? (
                                            <ReactTable columns={errorDetaileColumns} data={errorDetails} defaultPageSize={10} />
                                        ) : viewReportError ? <p>Error occurred. Unable to load view error reports.</p> : (
                                                <div className="no-data">No data found.</div>
                                            )}
                                    </Fragment>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                    </Modal.Footer>
                    {loading ? <Loader /> : null}
                </Modal>
            </Col>
        </Row>
    )
}

export default ErrorsPage;